import { Compass, ExternalLink } from 'lucide-react';
import type { SlotComponentProps } from '../../types';

const destinations = ['Workspace switcher', 'Pinned routes', 'Recent destinations'];

const NavigationalShortcutsBlock = (_props: SlotComponentProps) => {
  return (
    <div className="rounded-3xl border border-slate-200 bg-white p-6 shadow-sm">
      <div className="mb-4 flex items-center gap-3">
        <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-emerald-100 text-emerald-700">
          <Compass className="h-5 w-5" />
        </div>
        <div>
          <h2 className="text-xl font-semibold text-slate-900">Navigational shortcuts</h2>
          <p className="text-sm text-slate-500">Direct routing blocks appear when movement matters more than reading.</p>
        </div>
      </div>

      <div className="space-y-3">
        {destinations.map((destination) => (
          <button
            key={destination}
            className="flex w-full items-center justify-between rounded-2xl border border-slate-200 px-4 py-3 text-left text-sm text-slate-700 hover:border-slate-300 hover:bg-slate-50"
          >
            <span>{destination}</span>
            <ExternalLink className="h-4 w-4 text-slate-400" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default NavigationalShortcutsBlock;